import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PatientsTable from "../tables/PatientsTable";
import StatCard from "../UI/StatCard";
import { get } from "../../utility/fetchWeb";
import { get as gets } from "../../utility/fetch2";
import axios from "axios";

import { RiCalendar2Fill } from "react-icons/ri";
import { stats } from "./mockdata/PatientData";
import SearchInput from "../UI/SearchInput";
import AdmitCheck from "../Patient/AdmitCheck";
import HMOPatientsTable from "../tables/HMOPatientsTable";

function Patients() {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [assignedPatients, setAssignedPatients] = useState(0);
  const [outPatients, setOutpatients] = useState(0);
  const [waiting, setWaiting] = useState(0);
  const [admitted, setAdmitted] = useState(0);
  const [hmoPatients, setHmoPatients] = useState(0);
  const [summary, setSummary] = useState([0, 0, 0, 0, 0]);
  const [patientData, setPatientData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  const [selectedTab, setSelectedTab] = useState("patients");
  const [filteredDate, setFilteredDate] = useState(null);
  const [admittedPatients, setAdmittedPatients] = useState([]);
  const [hmoPatientsList, setHmoPatientsList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const doctorId = sessionStorage.getItem("userId");

  const getTableData = async () => {
    try {
      // const data = await get(`/patients/assignedtodoctor`);
      // setPatientData(data.data);
      // setFilteredData(data.data); // Initialize filtered data with all patient data
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  //done
  const getAssigned = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/medicals/api/dashboard/assignedtodoctor?status=1`,
        config,
      );
      setAssignedPatients(res.data || 0);
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  const getOutPatients = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/medicals/api/dashboard/AllPatientCount?status=1`,
        config,
      );
      setOutpatients(res.data || 0);
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  const getWaiting = async () => {
    try {
      const data = await get(`/Appointment/doctor/${doctorId}`);
      console.log("Waiting patients: ", data?.data);
      if (data?.status === "success") {
        // // Filter for admitted patients
        // const admittedPatients = data?.data?.filter(
        //   (patient) => patient.isAdmitted === true
        // );
        // setAdmittedPatients(admittedPatients || []);

        // Keep original patient data for other purposes
        setPatientData(data?.data || []);
      } else {
        // setAdmittedPatients([]);
        setPatientData([]);
      }
    } catch (e) {
      console.log("Error: ", e);
      setAdmittedPatients([]);
      setPatientData([]);
    }
  };
  const getAdmitted = async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        console.error("Token not found in session storage");
        return;
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      let res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/medicals/api/ServiceTreatment/list/paginate/true/admitted-patients?pageNumber=1&pageSize=10`,
        config,
      );

      if (res.data?.data?.metadata?.totalItems) {
        setAdmitted(res.data.data.metadata.totalItems);
      }
    } catch (error) {
      console.error("Error fetching admitted patients:", error);
    }
  };

  //done
  const getHmoPatients = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const clinicId = sessionStorage.getItem("clinicId");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/medicals/api/HMO/all-patient-hmo/${clinicId}?pageIndex=1&pageSize=1000`,
        config,
      );
      const patientsList = res?.data?.data || [];
      setHmoPatients(patientsList?.length || 0);
      setHmoPatientsList(patientsList); // Store full patient list for table display
    } catch (e) {
      console.log("Error: ", e);
      setHmoPatients(0);
      setHmoPatientsList([]);
    }
  };

  const getAdmittedPatients = async (pageNumber = 1) => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        console.error("Token not found in session storage");
        return;
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      let res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/medicals/api/ServiceTreatment/list/paginate/true/admitted-patients?pageNumber=${pageNumber}&pageSize=10`,
        config,
      );

      if (res.data?.data?.recordList) {
        setAdmittedPatients(res.data.data.recordList);
      }
    } catch (error) {
      console.error("Error fetching admitted patients:", error);
    }
  };

  useEffect(() => {
    getAdmittedPatients(currentPage);
  }, [currentPage]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);

    await Promise.all([
      getAssigned(),
      getOutPatients(),
      getAdmitted(),
      getHmoPatients(),
      getWaiting(),
      getTableData(),
    ]);
    setLoading(false);
  };

  useEffect(() => {
    setSummary([assignedPatients, admitted, hmoPatients]);
  }, [assignedPatients, admitted, hmoPatients]);

  useEffect(() => {
    if (searchText === "") {
      dateFilter();
      return;
    }
    const filteredResults = patientData.filter(
      (patient) =>
        patient?.firstName
          ?.toLowerCase()
          ?.includes(searchText?.toLowerCase()) ||
        patient?.lastName?.toLowerCase()?.includes(searchText?.toLowerCase()),
    );

    setFilteredData(filteredResults);
  }, [searchText]);

  // Function to handle date change
  const handleDateChange = (date) => {
    setSelectedDate(date);
    setFilteredDate(date); // Set the filtered date
  };

  const dateFilter = async () => {
    await getTableData();
    setFilteredData(patientData);
    if (filteredDate) {
      const filteredResults = patientData.filter((patient) => {
        // Parse the date string into a Date object
        const patientDateRaw = patient?.dateCreated;

        const patientDate = new Date(patientDateRaw);

        // Extract the date components
        const patientYear = patientDate.getFullYear();
        const patientMonth = patientDate.getMonth();
        const patientDay = patientDate.getDate();

        // Extract the selected date components
        const selectedYear = filteredDate.getFullYear();
        const selectedMonth = filteredDate.getMonth();
        const selectedDay = filteredDate.getDate();

        // Compare the date components
        return (
          patientYear === selectedYear &&
          patientMonth === selectedMonth &&
          patientDay === selectedDay
        );
      });

      setFilteredData(filteredResults);
    } else {
      setFilteredData(patientData);
    }
  };
  useEffect(() => {
    dateFilter();
  }, [filteredDate]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const CustomInput = ({ value, onClick }) => (
    <button
      onClick={onClick}
      onKeyDown={(e) => e.preventDefault()} // Prevent typing in the date field
      className="custom-datepicker-input flex gap-6 flex-v-center"
    >
      {filteredDate ? formatDate(selectedDate) : "Select Date"}{" "}
      {/* Update this line */}
      <RiCalendar2Fill />
    </button>
  );

  const handleStatCardClick = (index) => {
    // Map card index to corresponding tab
    // 0 = Assigned Patients, 1 = Admitted Patients, 2 = Patients with HMO
    if (index === 0) {
      setSelectedTab("patients");
    } else if (index === 1) {
      setSelectedTab("admitted");
      setCurrentPage(1); // Reset to first page
    } else if (index === 2) {
      setSelectedTab("hmo"); // Show HMO patients table
    }
  };

  return (
    <div
      className="w-100 m-t-80"
      style={{ padding: "12px", boxSizing: "border-box" }}
    >
      {!loading ? (
        <div>
          <h3
            style={{
              fontSize: "clamp(1rem, 4vw, 1.5rem)",
              marginBottom: "12px",
            }}
          >
            Patients Management
          </h3>
          <div style={{ width: "100%", overflowX: "auto" }}>
            <div
              className="flex w-100 gap-8 m-t-20"
              style={{ flexWrap: "wrap", gap: "12px" }}
            >
              {stats.map((stat, index) => (
                <div
                  key={index}
                  onClick={() => handleStatCardClick(index)}
                  style={{
                    cursor: "pointer",
                    flex: "1 1 140px",
                    minWidth: "140px",
                    maxWidth: "100%",
                  }}
                >
                  <StatCard
                    data={stat}
                    number={summary[index]}
                    icon={stat.icon}
                  />
                </div>
              ))}
            </div>
          </div>
          <div
            className="flex flex-v-center w-100"
            style={{ flexWrap: "wrap", gap: "12px", marginTop: "20px" }}
          >
            <div
              className="flex gap-7"
              style={{ alignItems: "center", flexWrap: "wrap" }}
            >
              <p style={{ margin: 0, whiteSpace: "nowrap" }}>
                Waiting Patients
              </p>
              |
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                dateFormat="dd-MM-yyyy"
                maxDate={new Date()}
                customInput={<CustomInput />}
                icon={<RiCalendar2Fill />}
              />
            </div>

            <div
              style={{ flex: "1 1 200px", minWidth: "150px", maxWidth: "100%" }}
            >
              <SearchInput
                type="text"
                onChange={handleSearchChange}
                value={searchText}
                name="searchText"
              />
            </div>
          </div>
          <div
            className="tabs m-t-20 bold-text"
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              display: "flex",
              gap: "8px",
              paddingBottom: "8px",
            }}
          >
            <div
              className={`tab-item ${selectedTab === "patients" ? "active" : ""}`}
              onClick={() => setSelectedTab("patients")}
              style={{
                flexShrink: 0,
                padding: "8px 12px",
                fontSize: "clamp(0.75rem, 3vw, 0.95rem)",
              }}
            >
              Patients To See
            </div>
            <div
              className={`tab-item ${selectedTab === "admitted" ? "active" : ""}`}
              onClick={() => setSelectedTab("admitted")}
              style={{
                flexShrink: 0,
                padding: "8px 12px",
                fontSize: "clamp(0.75rem, 3vw, 0.95rem)",
              }}
            >
              Patients Currently Admitted
            </div>
            <div
              className={`tab-item ${selectedTab === "hmo" ? "active" : ""}`}
              onClick={() => setSelectedTab("hmo")}
              style={{
                flexShrink: 0,
                padding: "8px 12px",
                fontSize: "clamp(0.75rem, 3vw, 0.95rem)",
              }}
            >
              Patients with HMO
            </div>
          </div>
          <div
            style={{
              width: "100%",
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
            }}
          >
            {selectedTab === "patients" ? (
              <PatientsTable
                data={patientData}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                totalPages={totalPages}
              />
            ) : selectedTab === "admitted" ? (
              <AdmitCheck
                data={admittedPatients}
                setCurrent={setCurrentPage}
                currentPage={currentPage}
                totalPages={totalPages}
                setCurrentPage={setCurrentPage}
              />
            ) : (
              <HMOPatientsTable data={hmoPatientsList} />
            )}
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <div
            className="spinner"
            style={{ display: "inline-block", width: 48, height: 48 }}
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ animation: "spin 1s linear infinite" }}
            >
              <circle
                cx="24"
                cy="24"
                r="20"
                stroke="#2563eb"
                strokeWidth="4"
                fill="none"
                strokeDasharray="100"
                strokeDashoffset="70"
              />
            </svg>
            <style>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
          </div>
        </div>
      )}
    </div>
  );
}

export default Patients;
